export enum GenderTypeEnum {
  NONE = 0,
  MALE = 1,
  FEMALE = 2,
}
